<template>
    <div>
        <router-view v-show="$route.matched.length==3"></router-view>
        <PageHeaderLayout v-show="$route.matched.length==2">
            <div class="main-page-content" style="margin-top: 20px;">
                <el-row>
                    <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
                        <el-form-item label="公司名称">
                            <el-input v-model="searchCondition.corp_name" placeholder="输入公司名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchButton">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
                <!-- <el-tabs v-model="corp_type" type="card" @tab-click="handleClick" >
                    <el-tab-pane v-for="(item, index) in this.tabsList" :label="item.label" :key="index" :name="item.name" class="tab-item">
                    </el-tab-pane>
                </el-tabs> -->
                <ApeTable v-permission:issue_list
                    ref="apeTable"
                    :data="dataList"
                    :columns="columns"
                    :loading="loadingStaus"
                    :pagingData="pagingData"
                    highlight-current-row
                    @switchPaging="switchPaging"
                >
                <el-table-column
                    width="180"
                    align="center"
                    label="操作"
                >
                        <template slot-scope="scope">
                            <el-button v-permission:issue_configure size="mini" type="infor" @click="toInfo(scope.row.id)">查看</el-button>
                        </template>
                    </el-table-column>
                </ApeTable>
            </div>
        </PageHeaderLayout>
    </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ModalDialog from '@/components/ModalDialog'
import UploadFile from "@/components/UploadFile";
import ApeTable from "@/components/ApeTable";
import tzForm from "@/components/tz-form";
import DatePicker from '@/components/DatePicker.vue'
import { mapGetters } from 'vuex'
export default {
    components: {
        tzForm,
        PageHeaderLayout,
        ApeTable,
        ModalDialog,
        UploadFile,
        DatePicker
    },
    data() {
        return {
            not_select:false,
            type:0,
            id:'',
            formButtonArr:[
                {
                    label: '确定',
                    type: 'primary',
                    flag: 'add'
                }
            ],
            is_show_form:false,
            loadingStaus: false,
            corp_type: '1',
            tabsList: [
                {
                    label: '人资公司',
                    name: '1'
                },
                {
                    label: '用工企业',
                    name: '2'
                },
            ],
            // 分页信息
            pagingData:{
                is_show: true,
                layout: 'total, sizes, prev, pager, next, jumper',
                total: 0
            },
            dataList: [],
            columns: [
                {
                    title: "公司名称",
                    value: "company_name",
                    header_align: "center",
                    align: "center",
                    width:140
                },
                {
                    title: "公司负责人",
                    value: "contact",
                    header_align: "center",
                    align: "center",
                },
                {
                    title: "负责人手机号",
                    value: "contact_phone",
                    header_align: "center",
                    align: "center",
                    width:100
                },
                {
                    title: "问卷名称",
                    value: "title",
                    header_align: "center",
                    align: "center",
                    width:200
                },
                {
                    title: "填写时间",
                    value: "created_at",
                    header_align: "center",
                    align: "center",
                },
            ],
            searchCondition:{
                status:'',
                corp_name:'',
            },
            // typeList:[
            //     {id:'0',name:'待审核'},
            //     {id:'1',name:'审核通过'},
            //     {id:'2',name:'审核拒绝'}
            // ],
        };
    },
    watch: {
    },
    methods: {
        // 公司详情
        toInfo(id){
            // if(!id) return;
            this.$router.push({
                path: "questionnaire/info",
                query: {id: id}
            })
        },
        // 重置分页
        async resetPage() {
            this.$refs.apeTable.currentPage = 1
        },
        // 切换页码操作
        async switchPaging() {
            this.init();
        },
        // 搜索
        searchButton() {
            this.resetPage()
            console.log(this.searchCondition,99999)
            this.init('search')
        },
        //获取列表
        async init(type) {
            this.loadingStaus=true
            let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
            let searchCondition = this.handleSearchCondition()
            Object.assign(searchCondition,pagingInfo)
            this.dataList = []
            let { data, pages} = await this.$api.getQuestionnaireList(searchCondition)
            this.$nextTick(() => {
                this.dataList=data
            })
            this.pagingData.total = pages.total
            this.offset = pages.offset
            this.loadingStaus=false
        },
        // 处理搜索条件
        handleSearchCondition() {
            let condition = {}
            if (this.searchCondition.corp_name) {
                condition.corp_name = this.searchCondition.corp_name
            }
            
            if(this.corp_type){
                condition.corp_type = this.corp_type
            }
            
            return condition
        },
        //点击tab切换
        async handleClick(tab) {
            this.searchCondition={status:'',corp_name:'',time:''};
            this.corp_type = tab.name;
            this.resetPage()
            this.init()
        },
        async updateStatus(project_status){
            this.corp_type = project_status;
        }
    },
    computed: {
        ...mapGetters(['userPermissions'])
    },
    mounted() {
        this.resetPage()
        if(this.$route.query.type&&this.$route.query.type!='undefined') {
            this.updateStatus(this.$route.query.type)
        }
        this.init();
    },
};
</script>

<style lang="stylus" scoped>
.el-button
  margin-right 4px
  margin-bottom 4px
.operation-btn
  margin: 0 20px
.el-button + .el-button
  margin-left: 0
.item-info {
  display: flex;
  flex-direction: row;
}

.item-info-left {
  width: 130px;
  height: 130px;
}

.item-info-right {
  width: 200px;
  padding: 15px;
  line-height: 40px;
}

.item-info-title {
  color: #aeaeb2;
  font-size: 18px;
}

.item-info-price {
  color: #101010;
  font-size: 28px;
}

el-radio-group{
 display :flex;    
}

.item-info-progress {
  width: 76px;
  height: 11px;
  border: 1px solid black;
}

</style>